import React from 'react';
import PropTypes from 'prop-types';
import { Box, makeStyles } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';

import Title from './title';
import TimestampIssueItem from './TimestampIssueItem';
import AmberTooltip from '../../tooltips/AmberTooltip';

const useStyles = makeStyles((theme) => ({
  boxColor: {
    color: theme.palette.custom.charcoalGray,
  },
}));
export default function FormattingPanel(props) {
  const { formattingIssues, translate, onSeekToTime, selectedItemId, onItemSelection } = props;
  const classes = useStyles();

  const adaptedMessage = () =>
    formattingIssues.length > 1
      ? 'EDITOR.PRE_QC.formattingIssuesFound'
      : 'EDITOR.PRE_QC.formattingIssueFound';

  return (
    <Box data-testid="pre-qc-box-formatting-panel">
      <Box
        display="flex"
        alignItems="center"
        paddingLeft={2.75}
        marginTop={3}
        flexDirection="row"
        gridRowGap={2}
      >
        <Title
          text={`${formattingIssues.length}${translate(adaptedMessage())}`}
        />
        <AmberTooltip
          tooltip={translate('EDITOR.PRE_QC.formattingInfoTooltip')}
          testid="pre-qc-formatting-info-tooltip"
        >
          <InfoIcon
            sx={{ color: 'custom.gray', pl: 1 }}
            data-testid="pre-qc-formatting-info-icon"
          />
        </AmberTooltip>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        paddingLeft={2.75}
        paddingRight={2.75}
        className={classes.boxColor}
        marginTop={2}
        gridRowGap={8}
      >
        {formattingIssues.length !== 0 &&
          formattingIssues.map((item, index) => (
            <Box
              key={`pre-qc-formatting-issue-${index}`}
              display="flex"
              fontSize={{ xs: 10, sm: 12, md: 12, lg: 14, xl: 14 }}
              data-testid={`pre-qc-formatting-issue-${index}`}
            >
              <TimestampIssueItem item={item} onSeekToTime={onSeekToTime} selectedItemId={selectedItemId} onItemSelection={onItemSelection} />
            </Box>
          ))}
      </Box>
    </Box>
  );
}

FormattingPanel.propTypes = {
  formattingIssues: PropTypes.arrayOf(
    PropTypes.shape({
      original_text: PropTypes.string.isRequired,
      start_time: PropTypes.number.isRequired,
    })
  ),
  translate: PropTypes.func.isRequired,
  onSeekToTime: PropTypes.func,
  selectedItemId: PropTypes.string,
  onItemSelection: PropTypes.func,
};

FormattingPanel.defaultProps = {
  formattingIssues: [],
};
